import { NgcCookieConsentConfig, provideNgcCookieConsent } from 'ngx-cookieconsent';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  ApplicationConfig,
  ErrorHandler,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection
} from '@angular/core';
import {
  provideHttpClient, withFetch, withInterceptors
} from '@angular/common/http';
import { provideRouter, withRouterConfig } from '@angular/router';
import { providePrimeNG } from 'primeng/config';

import { routes } from './app.routes';
import { authInterceptor } from './features/auth/interceptors/auth.interceptor';
import { environment } from 'src/environments/environment';
import { Velocity } from './themes/velocity';
import { provideAppState } from './common/providers/app-state-provider';
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import { ConfirmationService, MessageService } from 'primeng/api';
import { provideServiceWorker } from '@angular/service-worker';
import { ChunkLoadErrorHandler } from './common/error-handlers/chunk-load-error.handler';
import { provideChunkLoadNavigationRecovery } from './common/error-handlers/chunk-nav-recovery';

ModuleRegistry.registerModules([AllCommunityModule]);

export const appConfig: ApplicationConfig = {
  providers: [
    ConfirmationService,
    MessageService,
    provideNgcCookieConsent(environment.cookieConsentConfig as NgcCookieConsentConfig),
    provideBrowserGlobalErrorListeners(),
    {
      provide: ErrorHandler,
      useClass: ChunkLoadErrorHandler,
    },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Velocity,
        options: { darkModeSelector: 'none' },
      },
    }),
    provideRouter(routes, withRouterConfig({ onSameUrlNavigation: 'reload' })),
    provideChunkLoadNavigationRecovery(),
    provideAppState(),
    provideHttpClient(withInterceptors([authInterceptor]), withFetch()),
    provideServiceWorker('ngsw-worker.js', {
      enabled: environment.sw,
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
};
